import React, { memo } from 'react'
import { HeadingText, Link, BodyText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import {
  PRIVACY_HOME,
  PRIVACY_MERCHANT_HOME_FROM_DAR,
} from '../../constants/constants'
import serverData from '../../utils/server-data'
const { isMerchantUser } = serverData
const PrivacyChoices = memo((props) => (
  <div className="privacyHub-model">
    <HeadingText
      id="privacyChoicesHeader"
      className="privacyHub-model-heading"
      size="lg"
    >
      <Message id="privacyhub.privacychoices.header" />
    </HeadingText>
    <BodyText size="lg" className="privacyHub-model-content">
      <Message
        id="privacyhub.privacychoices.component.desc"
        link={(innerMessage) => (
          <Link
            id="privacySettingsLink"
            name="privacy_settings"
            href={
              isMerchantUser ? PRIVACY_MERCHANT_HOME_FROM_DAR : PRIVACY_HOME
            }
          >
            {innerMessage}
          </Link>
        )}
      />
    </BodyText>

    {props.content(props.keys && props.keys.privacychoices)}
  </div>
))

PrivacyChoices.displayName = 'PrivacyChoices'

export default PrivacyChoices
